import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "v-error" }
const _hoisted_2 = { class: "main" }
const _hoisted_3 = { class: "main__content" }
const _hoisted_4 = { class: "main__action" }

import {RefreshCcw04} from "utruckin-icons";
import CommonButton from "@/components/common/CommonButton.vue";
import {useRoute, useRouter} from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'PermissionView',
  setup(__props) {

const router = useRouter();
const route = useRoute();

const goBack = () => {
  router.go(-1);
}

const goHome = () => {
  router.push("/");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(route).name), 1),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "main__headline" }, " Access denied ", -1)),
      _cache[1] || (_cache[1] = _createElementVNode("div", { class: "main__description" }, " You’re logged in, but you don’t have access to this resource. If you believe this is a mistake, contact support or your administrator. ", -1)),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(CommonButton, {
          onClick: goBack,
          type: "outline",
          prepend: "",
          "prepend-icon": _unref(RefreshCcw04),
          label: "Refresh"
        }, null, 8, ["prepend-icon"]),
        _createVNode(CommonButton, {
          onClick: goHome,
          type: "primary",
          label: "Go to home"
        })
      ])
    ])
  ]))
}
}

})